import { useT } from '../i18n/LanguageContext';
import { EDITABLE_SLIDES } from '../admin/editableSlides';

/* Injects admin-configured font sizes (German master only). */
export default function ContentStyles() {
  const { content, lang } = useT();
  if (lang !== 'de' || !content) return null;
  let css = '';
  EDITABLE_SLIDES.forEach((s) => {
    const st = (content[s.key] && content[s.key].styles) || {};
    ['overline', 'title', 'body'].forEach((k) => {
      const px = st[k];
      const sel = s.fontTargets && s.fontTargets[k];
      if (px && sel) css += `${sel} { font-size: ${px}px !important; }\n`;
    });
  });
  return css ? <style data-testid="content-styles">{css}</style> : null;
}
